import { assign, keyBy, orderBy } from 'lodash';
import { ADD_EXPENSE_BUCKETS_WITH_TAGS, ADD_EXPENSE_BUCKETS_WITH_TAGS_BY_ID, EXPENSE_BUCKETS_ADD_EXPENSE_BUCKETS_FOR_USER, SET_EXPENSE_BUCKET_WITH_TAGS_BY_ID_LOADING, SET_EXPENSE_BUCKET_WITH_TAGS_LOADING } from '@Actions/expenseBucketsWithTagsActions';
export const defaultState = {
    expenseBucketsWithTagsLoading: false,
    expenseBucketsWithTagsByIdLoading: false,
    dropdownExpenseBucketsWithTags: [],
    activeExpenseBucketsWithActiveTags: [],
    activeExpenseBucketsById: {},
    expenseBucketsByUser: {},
    expenseTagBucketsById: null
};
export function expenseTagBucketsReducer(state = defaultState, action) {
    function order(buckets) {
        buckets.forEach(function (bucket) {
            bucket.expense_tags = orderBy(bucket.expense_tags, ['disabled', 'name'], ['asc', 'asc']);
        });
        return buckets;
    }
    switch (action.type) {
        case ADD_EXPENSE_BUCKETS_WITH_TAGS: {
            const activeBuckets = [];
            for (const bucket of action.payload) {
                if (!bucket.disabled) {
                    const activeBucket = Object.assign({}, bucket);
                    const activeTags = [];
                    for (const tag of bucket.expense_tags) {
                        if (!tag.disabled) {
                            activeTags.push(Object.assign({}, tag));
                        }
                    }
                    activeBucket.expense_tags = activeTags;
                    activeBuckets.push(activeBucket);
                }
            }
            return assign({}, state, {
                dropdownExpenseBucketsWithTags: order(action.payload.filter((bucket) => bucket.is_dropdown)),
                activeExpenseBucketsWithActiveTags: order(activeBuckets),
                activeExpenseBucketsById: keyBy(activeBuckets, 'id')
            });
        }
        case EXPENSE_BUCKETS_ADD_EXPENSE_BUCKETS_FOR_USER: {
            return Object.assign(Object.assign({}, state), { expenseBucketsByUser: Object.assign(Object.assign({}, state.expenseBucketsByUser), { [action.payload.userId]: action.payload.expenseBuckets }) });
        }
        case SET_EXPENSE_BUCKET_WITH_TAGS_LOADING:
            return Object.assign(Object.assign({}, state), { expenseBucketsWithTagsLoading: action.payload });
        case SET_EXPENSE_BUCKET_WITH_TAGS_BY_ID_LOADING:
            return Object.assign(Object.assign({}, state), { expenseBucketsWithTagsByIdLoading: action.payload });
        case ADD_EXPENSE_BUCKETS_WITH_TAGS_BY_ID:
            return Object.assign(Object.assign({}, state), { expenseTagBucketsById: keyBy(action.payload, 'id') });
        default:
            return state;
    }
}
